import { ofType } from "redux-observable";
import { filter, mapTo } from "rxjs/operators";
import { selectSelectedBuildingInfo } from "../../../../selectors/selectExistingBuildingInfo";
import { selectIsTutorialActive } from "../../../../selectors/selectTutorial";
import { actionModalSwapLast } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { TypeBuildingAction } from "../../buildings/reducerBuildings";
import { TypeActionExpansions } from "../actionExpansions";
export var epicExpansionsSelect = function (action$, state$) {
    return action$.pipe(ofType(TypeActionExpansions.Select), filter(function () {
        return (state$.value.playerBase.buildings.action === TypeBuildingAction.None ||
            selectSelectedBuildingInfo(state$.value) == undefined) &&
            !selectIsTutorialActive(state$.value);
    }), mapTo(actionModalSwapLast(IdModal.PurchaseExpansion)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/expansions/epics/epicExpansionsSelect.ts
// module id = 2100
// module chunks = 3